import { Observable, Subject, Subscription } from 'rxjs';
import { ReportProperties } from '../../../_objects/report-element';
import { UpdateMetadata, PropertyPreviewMetadata, FieldType } from '../../../_services/report-template-design.service';
import { TemplateCommonSection } from './report-template';

export class ReportCommonSection extends ReportProperties {

  public onUpdateHeight: Observable<UpdateMetadata>;
  private onUpdateHeight$: Subject<UpdateMetadata>;

  private baseDef: TemplateCommonSection;
  private readonly metaId = 'id';
  private readonly metaHeight = 'height';

  constructor(type: 'Page Header' | 'Page Footer', templateDef: TemplateCommonSection) {

    super(type, templateDef ? templateDef.id : null);

    this.onUpdateHeight$ = new Subject();
    this.onUpdateHeight = this.onUpdateHeight$.asObservable();

    this.baseDef = templateDef;

    this.setChainUpdate();
    this.setPreviewMetadata();
  }

  public getHeightNum(): number {
    return this.baseDef.height;
  }
  public getHeight(): string {
    return [this.getHeightNum(), 'mm'].join('');
  }
  public getHeightPx(): number {
    return this.toPixel(this.getHeightNum(), 'mm');
  }

  public getTemplateJSON(): TemplateCommonSection {
    return this.baseDef;
  }

  protected getPreviewMetadata(): PropertyPreviewMetadata[] {
    return [
      {
        name: this.metaHeight, parentName: null, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: true,
        isEdited: false,
      }
    ];
  }

  protected setUpdateMetadata(metadata: UpdateMetadata) {
    switch (metadata.name) {
      case this.metaId:
        this.baseDef[metadata.name] = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaHeight:
        this.baseDef[metadata.name] = metadata.value as number;
        this.setPreviewValue(metadata.name, metadata.value);
        this.onUpdateHeight$.next(metadata);
        break;
    }
  }

  protected setChainUpdateFunction(subscribers: Array<Subscription>) { }
}
